/**
 * Список опросов
 * @return Promise
 */
const pollList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Объект опроса
 * data.id - обязательный параметр
 * @return Promise
 */
const pollGet = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Создание опроса
 * @return Promise
 */
const createPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/create",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Изменение опроса
 */
const editPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Дублирование опроса
 */
const copyPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/copy",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Удаление опроса
 */
const deletePoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Удаление ответа
 */
const deleteAnswerPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/deleteAnswer",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Восстановление ответа
 */
const recoveryAnswerPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/recoveryAnswer",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Восстановление опроса
 */
const recoveryPoll = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/poll/recovery",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Список хотспотов опроса
 * @return Promise
 */
const pollHotspotList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/pollUser/hotspotList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Список статистики опроса
 * @return Promise
 */
const pollGraphData = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/pollUser/getGraphData",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export {
  pollList,
  pollGet,
  createPoll,
  editPoll,
  copyPoll,
  deletePoll,
  deleteAnswerPoll,
  recoveryPoll,
  pollHotspotList,
  pollGraphData,
  recoveryAnswerPoll
};
